import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { ChartData } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

interface PropertyTypeChartProps {
  data: any; // Accepts data directly from parent
}

const PropertyTypeChart: React.FC<PropertyTypeChartProps> = ({ data }) => {
  const labels = Object.keys(data);
  const dataValues = Object.values(data) as number[];

  // Using light colors
  const lightColors = [
    '#4285F4', // Normal Blue
    '#DB4437', // Normal Red
    '#0F9D58', // Normal Green
  ];

  const chartData: ChartData<'pie'> = {
    labels: labels,
    datasets: [
      {
        label: '# of Properties',
        data: dataValues,
        backgroundColor: labels.map((_, i) => lightColors[i % lightColors.length]),
        borderColor: labels.map((_, i) => lightColors[i % lightColors.length]),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Property Distribution by Type',
      },
    },
  };

  return (
    <div className="h-72 w-full">
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default PropertyTypeChart;
